import * as types from 'ducks/types'
import { PlaybookApplicationType, PlaybookType } from 'app/types'

export const setQuickGuiddeMetadata = (payload: {
    qgTitle: string
    qgDescription: string
    qgApplications: Array<PlaybookApplicationType>
    qgNewTags: Array<string>
    qgTransition?: string
    commentsStatus?: PlaybookType['commentsStatus']
}) =>
    ({
        type: types.SET_QUICK_GUIDDE_METADATA,
        payload
    } as const)

export const setQuickGuiddeTitle = (payload: string) =>
    ({
        type: types.SET_QUICK_GUIDDE_TITLE,
        payload
    } as const)

export const setQuickGuiddeDescription = (payload: string) =>
    ({
        type: types.SET_QUICK_GUIDDE_DESCRIPTION,
        payload
    } as const)

export const setQuickGuiddeApplications = (payload: {
    qgApplications: Array<PlaybookApplicationType>
    qgDeletedApps: Array<PlaybookApplicationType>
}) =>
    ({
        type: types.SET_QUICK_GUIDDE_APPLICATIONS,
        payload
    } as const)

export const setQuickGuiddeTags = (payload: {
    qgNewTags: Array<string>
    qgDeletedTags: Array<string>
}) =>
    ({
        type: types.SET_QUICK_GUIDDE_TAGS,
        payload
    } as const)

export const setTransition = (payload: string) =>
    ({
        type: types.SET_TRANSITION,
        payload
    } as const)

export const setQuickGuiddeComments = (payload: Required<PlaybookType['commentsStatus']>) =>
    ({
        type: types.SET_QUICK_GUIDDE_COMMENTS,
        payload
    } as const)
